import { useSyncExternalStore } from "react";

const NAV_EVENT = "lustbucket:navigate";

function subscribe(callback: () => void) {
  window.addEventListener("popstate", callback);
  window.addEventListener(NAV_EVENT, callback);
  return () => {
    window.removeEventListener("popstate", callback);
    window.removeEventListener(NAV_EVENT, callback);
  };
}

function getSnapshot() {
  return window.location.pathname;
}

export function usePathname() {
  return useSyncExternalStore(subscribe, getSnapshot);
}

export function navigate(path: string, replace = false) {
  if (window.location.pathname === path && !replace) {
    return;
  }

  if (replace) {
    window.history.replaceState({}, "", path);
  } else {
    window.history.pushState({}, "", path);
  }

  window.dispatchEvent(new Event(NAV_EVENT));
}
